// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import { MDBCol, MDBContainer } from 'mdbreact';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SearchElement from './SearchElement';
import WorkOrderButtonControl from '../dashboard/workOrderButtonControl';
import { toggleModal } from '../../storage/actions/modalsActions';
import { getAccountBalanceByClient } from '../../storage/actions/profile';
import { localCurrencySettings } from '../../utils/constans';

const Offer = ({
  toggleModal,
  auth,
  profile,
  getSearched,
  hideControlButton = false,
  showInputRange = false,
  getAccountBalanceByClient,
}) => {
  useEffect(() => {
    if (auth?.user?.userType === 'client') {
      getAccountBalanceByClient();
    }
  }, []);

  return (<>
 
      <div className="dashboard-actions-bar">
          <SearchElement
            getSearchValues={getSearched}
            showInputRange={showInputRange}
          />
          <WorkOrderButtonControl
            hideControlButton={hideControlButton}
            openImportModal={() => toggleModal(true, 'importWorkOrderModal')}
            userType={auth.user.userType}
          />
    </div>
  </>);
};

const mapDispatchToProps = {
  toggleModal,
  getAccountBalanceByClient,
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Offer));
